import React, { useState, useEffect } from 'react';
import { PictureList } from './PictureList';
import { FolderList } from './FolderList';
import { useRecoilState } from 'recoil';
import { addPicturesState } from '../../../GlobalState';
import _ from 'lodash';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme, Button } from '@material-ui/core';
import { COLOR_LIGHT_GRAY, COLOR_WHITE } from '../../../const/Const';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import FolderIcon from '@material-ui/icons/Folder';
import { TLedgerPictur } from '../../../types/Ledger';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

type TProps = {
  setValue: any;
  getValues: any;
  watch: any;
};

export const AddField: React.FC<TProps> = (props: TProps) => {
  const { setValue, getValues, watch } = props;

  // 一括追加する写真達（左側に追加するために選択された写真達）
  const [addPictures, setAddPictures] =
    useRecoilState<TLedgerPictur[]>(addPicturesState);

  // 開いているフォルダーのID
  const [openFolder, setOpenFolder] =
    useState<{ id: number; name: string } | undefined>();

  // 写真一覧
  const [imageData, setImageData] = useState<TLedgerPictur[]>();

  const classes = useStyles({ openFolderId: openFolder?.id });

  // フォルダーの開閉
  const onSwitching = (folderId?: number, folderName?: string) => {
    const folderData =
      folderId && folderName ? { id: folderId, name: folderName } : undefined;
    setOpenFolder(folderData);
  };

  // 追加ボタン押下
  const onAddButton = () => {
    if (!imageData) {
      return;
    }
    const newData: TLedgerPictur[] = _.cloneDeep(imageData);
    setValue('pictures', newData.concat(addPictures));
    setAddPictures([]);
  };

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdDownScreen = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    setImageData(getValues('pictures'));
  }, [watch('pictures')]);

  return (
    <div className={classes.addField}>
      <div className={classes.content}>
        <div
          className={classes.header}
          style={{
            flexDirection: isSmDownScreen ? 'row' : 'column',
            justifyContent: isSmDownScreen ? 'space-between' : 'center'
          }}
        >
          <div className={classes.headerLeft}>
            <span style={{ marginLeft: 10 }}>写真選択</span>
          </div>
          <div className={classes.headerRight}>
            <span
              style={{ marginRight: 10 }}
            >{`${addPictures.length}枚選択中`}</span>
          </div>
        </div>
        {openFolder?.id && (
          <div
            style={{
              height: isSmDownScreen ? 80 : 'auto',
              width: '100%',
              borderLeft: 'solid 0.5px #808080',
              borderRight: 'solid 0.5px #808080'
            }}
          >
            <div
              style={{
                height: isSmDownScreen ? '50%' : 'auto',
                margin: '0px 10px'
              }}
              onClick={() => onSwitching()}
            >
              <ArrowBackIosIcon
                className={classes.arrowBackIosIcon}
                style={{ fontSize: isSmDownScreen ? 'medium' : 'small' }}
              />
              {/* 画面サイズによってスマホ表示に切り替える */}
              {isSmDownScreen ? (
                <span>フォルダ一覧へ</span>
              ) : (
                <span style={{ fontSize: '0.5em' }}>一覧へ</span>
              )}
            </div>
            <div
              style={{
                height: '50%',
                margin: '0px 10px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'start'
              }}
            >
              <FolderIcon
                className={classes.folderIcon}
                style={{
                  fontSize: isSmDownScreen ? 'none' : '0.7em',
                  marginRight: 10
                }}
              />
              <span
                style={{
                  fontSize: isMdDownScreen ? '1em' : '0.6em',
                  alignItems: 'center'
                }}
              >
                {openFolder.name}
              </span>
            </div>
          </div>
        )}
        <div className={classes.listArea}>
          {openFolder?.id ? (
            <PictureList openFolderId={openFolder?.id} imageData={imageData} />
          ) : (
            <FolderList onSwitching={onSwitching} />
          )}
        </div>
        <div
          style={{
            width: '100%',
            height: 70,
            borderLeft: `solid 0.5px ${COLOR_LIGHT_GRAY}`,
            borderRight: `solid 0.5px ${COLOR_LIGHT_GRAY}`,
            borderBottom: `solid 0.5px ${COLOR_LIGHT_GRAY}`,
            display: 'grid',
            placeItems: 'center'
          }}
        >
          <Button
            style={{
              backgroundColor: '#52555F',
              color: '#fff'
            }}
            variant='contained'
            color='secondary'
            onClick={onAddButton}
          >
            {/* 画面サイズによってスマホ表示に切り替える */}
            {isSmDownScreen ? (
              <span>選択した写真を追加する</span>
            ) : (
              <span style={{ fontSize: '0.5em' }}>
                選択した<br></br>写真を追加
              </span>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

type TStyleProps = {
  openFolderId: number | undefined;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    addField: {
      justifyContent: 'flex-end',
      width: '30%',
      backgroundColor: COLOR_WHITE
    },
    content: {
      display: 'flex',
      flexWrap: 'wrap',
      height: 300,
      margin: 10,
      marginTop: 170
    },
    header: {
      height: 40,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: COLOR_LIGHT_GRAY
    },
    headerLeft: {
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      fontSize: 14,
      color: COLOR_WHITE
    },
    headerRight: {
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      fontSize: 12,
      color: COLOR_WHITE
    },
    listArea: {
      height: props => (props.openFolderId ? 490 : 560),
      overflowY: 'scroll',
      width: '100%',
      border: `solid 0.5px ${COLOR_LIGHT_GRAY}`
    },
    arrowBackIosIcon: {
      color: COLOR_LIGHT_GRAY
    },
    folderIcon: {
      color: COLOR_LIGHT_GRAY
    }
  })
);
